import { useTranslations } from 'next-intl';

import DrupalImage from '@commons/components/Image/Drupal';
import TopoPatternImage from '@commons/components/Image/TopoPattern';
import FeaturedTile from '@commons/components/Tile/FeaturedTile';
import { FEATURED_TILE_IMAGE_SIZES } from '@commons/components/Tile/FeaturedTile';

import type { WebinarNodeProps } from '.';
import WebinarNodeCard from './Card';
import { WebinarNodeLink } from './GatedDrawer';

/**
 * Webinar node component for the Featured Tile display type.
 */

const WebinarNodeFeaturedTile = (props: WebinarNodeProps) => {
  const t = useTranslations();

  const {
    title,
    description,
    image,
    format,
    customLabel,
    customDate,
    ctaLabel,
    alias,
    link,
    isGated,
  } = props;

  if (!link) return <WebinarNodeCard {...props} />;

  const upperTitle = customLabel ? customLabel : format ? format.name : t('nodes.webinar.label');

  const renderedImage = image ? (
    <DrupalImage {...image} sizes={FEATURED_TILE_IMAGE_SIZES} />
  ) : (
    <TopoPatternImage alt={title} sizes={FEATURED_TILE_IMAGE_SIZES} />
  );

  const renderedTile = (
    <FeaturedTile
      tag={`${upperTitle} / ${customDate}`}
      title={title}
      description={description}
      buttonText={ctaLabel || t('commons.learnMore')}
      image={renderedImage}
      justify="end"
      className="w-100"
    />
  );

  return (
    <WebinarNodeLink
      alias={alias}
      link={link}
      isGated={isGated}
      ctaLabel={ctaLabel || t('commons.learnMore')}
      className="w-100"
    >
      {renderedTile}
    </WebinarNodeLink>
  );
};

export default WebinarNodeFeaturedTile;
